<template>
  <div class="v-footer">
    <div class="vf-tabs">
      <div :class="['btn', active == 'freezerZongHe' ? 'active' : '']" @click="clickTab('freezerZongHe')">
        综合态势
      </div>
      <div :class="['btn', active == 'freezerEnergy' ? 'active' : '']" @click="clickTab('freezerEnergy')">
        能耗详情
      </div>
      <div :class="['btn', active == 'freezerHistory' ? 'active' : '']" @click="clickTab('freezerHistory')">
        用电分析
      </div>
      <div :class="['btn', active == 'freezerDevice' ? 'active' : '']" @click="clickTab('freezerDevice')">
        设备管理
      </div>
      <div :class="['btn', active == 'freezerAdmin' ? 'active' : '']" @click="clickTab('freezerAdmin')">
        后台入口
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VFooter",
  data() {
    return {
      active: "freezerZongHe"
    };
  },
  computed: {
    getRoute() {
      return this.$route;
    },
  },
  mounted() {
    this.active = this.getRoute.name;
  },
  methods: {
    clickTab(index) {
      this.active = index;
      if (this.getRoute.name == index) return;
      this.goPage(index);
    },
    goPage(index) {
      switch (index) {
        case "freezerZongHe":
          this.$router.push({
            path: "/freezerZongHe",
          });
          break;
        case "freezerDevice":
          this.$router.push({
            path: "/freezerDevice",
          });
          break;
        case "freezerEnergy":
          this.$router.push({
            path: "/freezerEnergy",
          });
          break;
        case "freezerHistory":
          this.$router.push({
            path: "/freezerHistory",
          });
          break;
        case "freezerHuanJiing":
          this.$router.push({
            path: "/freezerHuanJiing",
          });
          break;  
        case "freezerAdmin":
          this.$router.push({
            path: "/",
          });
          break;    
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-footer {
  width: 100%;
  height: 78px;
  background: rgba(51,51,51,0.4);
  .vf-tabs {
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
  }
}

.btn {
  width: 120px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  font-weight: bold;
  background-color: rgba(31, 51, 89, 0.4);
  color: #e2e8f0;
  border: none;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-align: center;
}

.btn.active {
  background-color: #3b82f6;
  color: #fff;
}

.btn:hover {
  background-color: #1e3a8a;
}

</style>
